import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"

import Hero from '../components/Hero.js'
import SectionHeader from '../components/SectionHeader.js'
import Projects from '../components/Projects.js'
import DesignProjectsContainer from '../components/DesignProjects.js'
import Gallery from '../components/Gallery.js'
import DesignProjectCard from '../components/DesignProjectCard.js'
import ProjectCard from '../components/ProjectCard.js'

import '../styles.css'


export default function IndexPage({ data })  {
    return (
        <Layout>
            <Hero />
            <SectionHeader 
                title="Programming Projects" 
                to="/programming" />
            <div className="projects">
                { data.projects.edges.map(edge => <ProjectCard key={ edge.node.id } node={ edge.node }/>) }
            </div>
            <SectionHeader 
                title="Art and Design Projects" 
                to="/art" />
            <div key="designs" className="designProjects">
                { data.designs.edges.map(edge => <DesignProjectCard key={ edge.node.id } node={ edge.node }/>)}
            </div>
            <SectionHeader 
                title="Gallery" 
                to="/gallery" />
            <Gallery images={ data.gallery.edges } />
        </Layout>
    )
}

export const query = graphql`
    query IndexQuery {
        projects: allProjectsCsv(sort: { fields: [name], order: DESC }, limit: 3) {
            edges {
                node {
                    ...ProjectFragment
                }
            }
        }
        designs: allDesign(limit: 3) {
            edges {
                node {
                    url 
                    title 
                    description
                    image
                }
            }
        }
        gallery: allFile( filter: {
            sourceInstanceName: {eq: "gallery"},
            extension: {in: ["png", "jpg"]}
        }, limit: 7) {
            edges {
                node {
                    ...GalleryFragment
                }
            }
        }
    }
`
